import Divider from 'material-ui/Divider'
import FormsyText from 'formsy-material-ui/lib/FormsyText'
import Formsy from 'formsy-react'
import isURL from 'validator/lib/isURL'
import { validations } from 'consts'
import { CheckActions } from 'actions'
import { Nav, Button } from 'components'
import Enum from 'utils/Enum'
import FontIcon from 'material-ui/FontIcon';

import './setup.scss'

export default class Setup extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  static propTypes = {
    check: React.PropTypes.object.isRequired,
    detectedBlogUrl: React.PropTypes.string,
    detectedFeedUrl: React.PropTypes.string,
  }

  componentWillMount() {
    Formsy.addValidationRule('isUrl', (_, value) => isURL(String(value)))
  }

  deactivate() {
    CheckActions.deactivate(this.props.check.get('checkId'))
  }

  submit(data) {
    if (this.props.check.get('key') === Enum.CheckTypes.blog.key) {
      if (!data.warn_days || data.warn_days.length < 1)
        data.warn_days = 14
      if (!data.critical_days || data.critical_days.length < 1)
        data.critical_days = 28
    }

    CheckActions.activate(
      this.props.check.get('key'),
      this.props.check.get('typeId'),
      data,
      this.context.currentUser
    )
  }

  render() {
    const { check } = this.props
    const url = check.get('url') || this.context.currentUser.website
    let blogUrl = null
    let feedUrl = null

    let detectBlogMessage = null
    if (check.get('key') === Enum.CheckTypes.blog.key) {
      // if the check has already been set up, don't use the detected values
      if (check.get('blogUrl')) {
        blogUrl = check.get('blogUrl')
        feedUrl = check.get('feedUrl')
      } else if (!this.props.detectedBlogUrl || this.props.detectedBlogUrl.length < 1) {
        detectBlogMessage = (
          <div className="callout">
            <div className="flex-center--horizontal">
              <FontIcon className="material-icons small-spacing--right" style={{fontSize: 28}}>info_outline</FontIcon>
              <h4>Your blog couldn&apos;t be found automatically</h4>
            </div>
            <p className="body2 callout__note">Please enter the details below</p>
          </div>
        )
      } else {
        detectBlogMessage = (
          <div className="callout">
            <div className="flex-center--horizontal">
              <FontIcon className="material-icons small-spacing--right" style={{fontSize: 28}}>info_outline</FontIcon>
              <h4>Your blog details were found automatically</h4>
            </div>
            <p className="body2 callout__note">Please check the details below and correct if necessary</p>
          </div>
        )
        blogUrl = this.props.detectedBlogUrl
        feedUrl = this.props.detectedFeedUrl
      }
    }
    // Warning: These cause the textboxes to not be able to be typed in on production only- dev and staging are fine.
    //          Reason unknown.
    // validations='isUrl'
    // validationError={validations.url}
    return (
      <div>
        <Nav toolbarTitleText={`${check.get('name')}: Set up check`} />
        <div className="setup">
          <div className="setup__form-container">
          <h2 className="setup__form-heading">Set up Your {check.get('name')} Check</h2>
          <Formsy.Form onValidSubmit={::this.submit}>
            <div>
              { detectBlogMessage }
              { check.get('key') === Enum.CheckTypes.blog.key &&
                <div>
                  <h4 className="setup__form-field-title">What is your blog URL?</h4>
                  <p className="body2 setup__form-field-instructions">ex) blog.mycompany.com or mycompany.com/blog</p>
                  <FormsyText
                    name='blog_url'
                    value={blogUrl}
                    required
                    className="setup__form-field"
                    fullWidth={true}
                  />
                </div>
              }
              <div>
                <h4 className="setup__form-field-title">What is your website URL?</h4>
                <FormsyText
                  name='url'
                  defaultValue={url}
                  required
                  className="setup__form-field"
                  fullWidth={true}
                />
              </div>
              { check.get('key') === Enum.CheckTypes.blog.key &&
                <div>
                  <h4 className="setup__form-field-title">What is your blog feed URL in Atom or RSS format? <span className="body2">(optional)</span></h4>
                  <p className="body2 setup__form-field-instructions">If you leave this field blank and we&apos;ll try to find it automatically</p>
                  <FormsyText
                    name='feed_url'
                    value={feedUrl}
                    className="setup__form-field"
                    fullWidth={true}
                  />

                  <h4 className="setup__form-field-title">Warn me if I haven&apos;t blogged for this many days: <span className="body2">(optional)</span></h4>
                  <p className="body2 setup__form-field-instructions">14 days is the default if you don&apos;t enter a value</p>
                  <FormsyText
                    name='warn_days'
                    defaultValue={check.get('warnDays')}
                    validations='isNumeric'
                    validationError='Please enter only numbers'
                    className="setup__form-field"
                    fullWidth={true}
                  />

                  <h4 className="setup__form-field-title">Mark as critical if I haven&apos;t blogged for this many days: <span className="body2">(optional)</span></h4>
                  <p className="body2 setup__form-field-instructions">28 days is the default if you don&apos;t enter a value</p>
                  <FormsyText
                    name='critical_days'
                    defaultValue={check.get('criticalDays')}
                    validations='isNumeric'
                    validationError='Please enter only numbers'
                    className="setup__form-field"
                    fullWidth={true}
                  />
                </div>
              }
            </div>
            <Button
              type='Submit'
              buttonType="primary"
              label='Save and view my results'
            />
            { check.get('enabled') && check.get('disableable') &&
              <Button
                label='deactivate check'
                buttonType="secondary"
                onTouchTap={::this.deactivate}
                className="secondary-btn"
              />
            }
          </Formsy.Form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checker/Setup.js